import React from "react";
import PageSection from "../components/pageSection";
import Link from "../../link";

const ContactBCB = () => (
  <PageSection title="Contact">
    <p>
      Heeft u vragen of wilt u een wijziging doorgeven neem dan contact op met
      onze secretaris:
    </p>
    <p>
      Denise Van Agt
      <br />
      Frederika-gracht 16
      <br />
      6465 CR Kerkrade
      <br />
      Telefoon: 0630705316
      <br />
      E-mail:{" "}
      <Link href="mailto:bcb.secretaris@gmail.com">
        bcb.secretaris@gmail.com
      </Link>
    </p>
  </PageSection>
);

export default ContactBCB;
